import { Dispatch, SetStateAction } from "react";
import styles from "./styles.module.css";
import { LocalizedText } from "../../services/generated/client";

interface LanguageSwitcherProps {
  languageEditing: string;
  setLanguageEditing: Dispatch<SetStateAction<keyof LocalizedText>>;
  inForm: boolean;
}

const LanguageSwitcher = ({
  languageEditing,
  setLanguageEditing,
  inForm,
}: LanguageSwitcherProps) => {
  return (
    <div className={`${styles.languageSwitcher} ${inForm && styles.inForm}`}>
      <span
        className={
          languageEditing === "ka" ? styles.activeLabel : styles.inactiveLabel
        }
        onClick={() => setLanguageEditing("ka")}
      >
        KA
      </span>
      <span
        className={
          languageEditing === "en" ? styles.activeLabel : styles.inactiveLabel
        }
        onClick={() => setLanguageEditing("en")}
      >
        EN
      </span>
    </div>
  );
};

export default LanguageSwitcher;
